import {Validators} from "@angular/forms";
import {PasswordStrength} from "./services/a-b.service";

const strictPasswordValidator = Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z\d]).{8,}$/);
const relaxedPasswordValidator = Validators.minLength(6);

const strictPasswordValidationErrorMessage = 'Your password needs to be at least 8 characters including a lower-case letter, an upper-case letter, a number and one special character (!@#$%^&*)';
const relaxedPasswordValidationErrorMessage = 'Your password needs to be at least 6 characters';

export function getPasswordValidator(strength: PasswordStrength) {
  return strength === 'relaxed' ? relaxedPasswordValidator : strictPasswordValidator;
}

export function getPasswordValidationErrorMessage(strength: PasswordStrength) {
  return strength === 'relaxed' ? relaxedPasswordValidationErrorMessage : strictPasswordValidationErrorMessage;
}
